import { TypeEntity, TypeUser } from "../../../enums/enums";
import firebase from "firebase";
import { IUserDoc } from "../doc/IUserDoc";
import { EntityForm } from "../../superAdmin/form/EntityFrom";
import { IUserForm } from "../form/IUsersForm";

export function setEntityFormToUser(entity: EntityForm, uid: string): IUserDoc {
  let userreturn: IUserDoc = {
    id: entity.id,
    createdAt: firebase.firestore.Timestamp.now(),
    typeDoc: "",
    document: entity.id,
    firstName: entity.firstName,
    secondName: entity.secondName,
    firstLastName: entity.surname,
    secondLastName: entity.secondSurname,
    fullName: `${entity.firstName?.trim()} ${entity.secondName?.trim()} ${entity.surname?.trim()} ${entity.secondSurname?.trim()}`,
    username: "",
    email: entity.email,
    mobilePhone: entity.phone,
    address: entity.address,
    profileImage: null,
    active: entity.active,
    rol: TypeUser.ADMIN,
    restricUser: false,
    idEntity: entity.nit,
    uid: uid,
    modules: [],
    businessName: entity.businessName,
    offices: [],
    country: entity.country,
    department: entity.department,
    town: entity.town,

    // daneCode: entity.daneCode,
    // entityType: TypeEntity.PUBLIC,
    // nit: entity.nit,
    // sigepCode: entity.sigepCode,
  };

  return userreturn;
}

export function setUserFormToUSer(user: IUserForm, uid: string): IUserDoc {
  let userreturn: IUserDoc = {
    id: user.id,
    createdAt: firebase.firestore.Timestamp.now(),
    typeDoc: user.typeDoc,
    document: user.document,
    firstName: user.firstName,
    secondName: user.secondName,
    firstLastName: user.firstLastName,
    secondLastName: user.secondLastName,
    fullName: `${user.firstName?.trim()} ${user.secondName?.trim()} ${user.firstLastName?.trim()} ${user.secondLastName?.trim()}`,
    username: `${user.firstName}${user.secondName} ${user.firstLastName} ${user.secondLastName}`.trim(),
    email: user.email,
    mobilePhone: user.mobilePhone,
    address: user.address,
    profileImage: null,
    active: user.active,
    rol: TypeUser.OFFICER,
    restricUser: false,
    idEntity: user.idEntity,
    uid: uid,
    modules: [],
    businessName: user.businessName,
    offices: [],
    country: user.country,
    department: user.department,
    town: "",

  };

  return userreturn;
}